import defaultTheme from '../defaultTheme';

export default ['none', '0px 5px 15px rgba(116, 124, 130, 0.3)', ...defaultTheme.shadows];
